import api from "@services/api-service";
import queryParams from "@services/repository-service";

const store = {
  // ////////////////////////////////////////////
  // STATE
  // ////////////////////////////////////////////

  state: {
    loading: false,
    data: [],
    links: {},
    meta: {}
  },

  // ////////////////////////////////////////////
  // MUTATIONS
  // ////////////////////////////////////////////

  mutations: {
    RESET_BENEFICIARIOS: state => {
      state.beneficiarios.loading = false;
    },

    SET_BENEFICIARIOS_LOADING: (state, loading) => {
      state.beneficiarios.loading = loading;
    },

    SET_BENEFICIARIOS: (state, { data, links, meta }) => {
      state.beneficiarios.data = data;
      state.beneficiarios.links = links;
      state.beneficiarios.meta = meta;
    }
  },

  // ////////////////////////////////////////////
  // GETTERS
  // ////////////////////////////////////////////

  getters: {
    isBeneficiariosLoading: state => () => {
      return state.beneficiarios.loading;
    },

    getBeneficiarios: state => () => {
      return state.beneficiarios.data;
    },

    getBeneficiario: state => () => {
      return state.beneficiarios.beneficiario;
    },

    getBeneficiariosMeta: state => () => {
      return state.beneficiarios.meta;
    },

    getBeneficiariosLinks: state => () => {
      return state.beneficiarios.links;
    }
  },

  // ////////////////////////////////////////////
  // ACTIONS
  // ////////////////////////////////////////////

  actions: {
    FETCH_BENEFICIARIOS(
      { commit, state },
      { page, cod, nome, rg, cpf, sortedBy, orderBy }
    ) {
      // Se ja esta buscando
      if (state.beneficiarios.loading) return;

      commit("SET_BENEFICIARIOS_LOADING", true);
      api()
        .get(`clientes`, {
          params: queryParams({
            page: page,
            relationships: [],
            where: [
              ["id", "=", cod],
              ["nome", "like", nome],
              ["rg", "like", rg],
              ["cpf", "like", cpf]
            ],
            sortedBy: sortedBy,
            orderBy: orderBy
          })
        })
        .then(response => {
          if (response.data.status) {
            commit("SET_BENEFICIARIOS", response.data);
          }
        })
        // .catch(error => {})
        .finally(() => commit("SET_BENEFICIARIOS_LOADING", false));
    },

    FETCH_USUARIO({ commit }, cliente_id) {
      api()
        .get(`clientes/${cliente_id}`, {
          params: queryParams({
            relationships: ["estadoCivil", "entidade"]
          })
        })
        .then(response => {
          if (response.data.status) {
            commit("SET_BENEFICIARIOS", response.data);
          }
        });
    },

    RESET_BENEFICIARIOS({ commit }) {
      commit("RESET_BENEFICIARIOS");
    }
  }
};

export default store;
